import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { InputFile } from "../../../../shared/components/InputFile";
import { removeAllFiles } from "../../../../shared/helpers/handleFiles";
import { IDocument } from "../../../../shared/model/document.model";

interface IProps {
  formik: any;
}
export const Files = (props: IProps) => {
  const cvRef = useRef<HTMLInputElement>(null);
  const documentFrontRef = useRef<HTMLInputElement>(null);
  const documentBackRef = useRef<HTMLInputElement>(null);
  const titles = ["Curriculum vitae", "DNI frente", "DNI dorso"];
  const refs = [cvRef, documentFrontRef, documentBackRef];
  const names = ["documents[0]", "documents[1]", "documents[2]"];
  const [showFields, setShowFields] = useState<boolean>(false);

  const { formik } = props;
  useEffect(() => {
    if (formik.values.documents.some((item: IDocument) => item?.file !== "")) {
      setShowFields(true);
    }
  }, [formik.values]);

  const cancelAddFile = () => {
    removeAllFiles(names, formik, refs);
    setShowFields(!showFields);
  };
  return (
    <>
      {/* Archivos */}
      <Row className="title-form not-first-title">Archivos</Row>
      {showFields ? (
        <>
          <Row>
            <Col className="d-flex justify-content-end">
              <Button
                className="btn-delete-item"
                outline
                onClick={cancelAddFile} // remove a field from the list
              >
                <span className="d-md-inline">
                  <FontAwesomeIcon icon={faTrash} />
                </span>
              </Button>
            </Col>
          </Row>
          <Row className="container-inputs-form">
            {formik.values?.documents?.length > 0 &&
              formik.values.documents.map((doc: IDocument, ind: number) => (
                <Col md={"6"} key={ind}>
                  <InputFile
                    formik={formik}
                    title={titles[ind]}
                    nameFile={`documents[${ind}].name`}
                    defaultValue={
                      formik.values?.documents[ind]?.file
                        ? formik.values?.documents[ind]?.file
                        : ""
                    }
                    refInput={refs[ind]}
                    nameProp={`documents[${ind}]`}
                  />
                </Col>
              ))}
          </Row>
          <hr></hr>
        </>
      ) : (
        <Row>
          <Col className="d-flex justify-content-end align-items-end">
            <Button
              className="btn-link-card"
              outline
              onClick={() => setShowFields(!showFields)}
            >
              Agregar archivos
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};
